<template>
  <svg :style="iconStyle" :width="width" :height="height" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5625 7L7.5625 13L19.5625 1" :stroke="stroke" stroke-width="2"/>
  </svg>
</template>

<script>
  export default {
    name: 'icon-success',
    props: {
      stroke: {
        type: String,
        default: '#000'
      },
      width: {
        type: String,
        default: '21'
      },
      height: {
        type: String,
        default: '15'
      },
      iconStyle: {
        type: Object,
        default: null
      }
    }
  }
</script>
